export enum MmbStage {
  CHECK_IN = 'check-in',
  CHECK_IN_FLOW = 'check-in-flow',
  LOGIN = 'login',
  VIEW = 'view',
  PASSENGERS = 'passengers',
  TRAVEL_PREPARATION = 'travelPreparations',
  REVIEW = 'review',
  CHECKOUT = 'checkout',
  CONFIRMATION = 'confirmation',
  CAR_RENTAL = 'carRental',
  TRAVEL_INSURANCE = 'travelInsurance',
  HOTELS_AND_ACTIVITIES = 'hotelsAndExperiences',
  TRAVEL_EXTRAS = 'travelExtras',
}

export enum MmbError {
  BOOKING_NOT_FOUND = 'bookingNotFound',
  BOOKING_CANCELLED = 'bookingCancelled',
  GROUP_BOOKING = 'groupBooking',
  GROUP_BOOKING_NOT_FOUND = 'groupBookingNotFound',
  GROUP_BOOKING_LOGGING_WITH_INFANT = 'groupBookingLoggingWithInfant',
  GROUP_BOOKING_NOT_TICKETED = 'groupBookingNotTicketed',
  SEVERAL_RECORDS_FOR_TRAVEL_DOCUMENT = 'severalRecordsForTravelDocument',
  UNEXPECTED_ERROR = 'unexpectedError',
}

export enum BoundStatus {
  REBOOKED = 'rebooked',
  CANCELLED = 'cancelled',
  ORIGINAL = 'original',
  NEW = 'new',
  DEFAULT = 'default',
}

export enum BoundSelectionType {
  ALL = 'all-bounds',
  SOME = 'some-bounds',
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
  NONE = 'no-bounds',
}

export enum CheckInStep {
  PASSENGERS = 'passengers',
  CHILD_SAFETY_NOTICE = 'child-safety-notice',
  APIS = 'apis',
  SEATMAP = 'seatmap',
  KYT = 'know-your-trip',
  RULES = 'rules',
  CONFIRMATION = 'confirmation',
  VOLUNTARY_DENIED_BOARDING = 'voluntary-denied-boarding',
}

export enum ExpediaSupportedCountry {
  Finland = 'fi',
  Germany = 'de',
  Ireland = 'ie',
  UnitedKingdom = 'uk',
  Sweden = 'se',
}

export enum TravelInsuranceEligibilityId {
  TRAVEL_INSURANCE_24_HOUR = 'TRAVEL_INSURANCE_24_HOUR',
  TRAVEL_INSURANCE_48_HOUR = 'TRAVEL_INSURANCE_48_HOUR',
  TRAVEL_INSURANCE = 'TRAVEL_INSURANCE',
}
